import React, { createContext, useContext, ReactNode } from 'react';

interface FullscreenContextType {
  handleFullscreenToggle: () => void;
}

const FullscreenContext = createContext<FullscreenContextType | undefined>(undefined);

export const useFullscreenContext = () => {
  const context = useContext(FullscreenContext);
  if (!context) {
    throw new Error('useFullscreenContext must be used within a FullscreenProvider');
  }
  return context;
};

interface FullscreenProviderProps {
  children: ReactNode;
  handleFullscreenToggle: () => void;
}

export const FullscreenProvider: React.FC<FullscreenProviderProps> = ({
  children,
  handleFullscreenToggle,
}) => {
  return (
    <FullscreenContext.Provider value={{ handleFullscreenToggle }}>
      {children}
    </FullscreenContext.Provider>
  );
};